<template>
  <span>
    Booking
    <router-link
      tag="a"
      :to="`/bookings/overview/:date?${eventLog.bookingId}`"
      >#{{ eventLog.bookingId }}
    </router-link>
    paid
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionBookingPaid',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
